var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('buy-button',{attrs:{"ticket":null,"can_buy_now":false,"event_expired":_vm.event_expired,"limited":_vm.limited,"sold_out":_vm.sold_out,"ticket_price":_vm.ticket_price,"ticket_id":_vm.ticket_id},on:{"buttonClick":function($event){_vm.addToBasket()}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331520e3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/tickets/SeasonTicketListItem.vue
// module id = 2yZH
// module chunks = 0